import Vue from 'vue'
import store from "@/core/store";

Vue.mixin({
    methods: {
        hasPermissionTo(permission) {
            return Object.values(store.getters.permissions).includes(permission)
        },
        hasAnyPermissionsTo(...permissions) {
            return Object.values(store.getters.permissions).some((permission) => {
                return permissions.includes(permission)
            })
        }
    }
})


